import {ContentDispatch} from 'framework';
import Flyout from 'go/components/flyoutPanel/FlyoutPanel';
import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectWithCore} from 'framework/hocs';
import {DynamicComponent} from 'go/components/dynamic/dynamicComponent';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';

import {FemaGoModal} from 'app-ui-componentlibrary';
import {compileContent, calculateStatuses} from 'common/utils';
import {SHOW_HIDE, SECTION_RESULTS} from 'app-ui-componentlibrary/dist/common/constants';

// TODO move to utils

export class ReviewPanel extends DynamicComponent {
  componentDidUpdate() {
    const {validationErrors} = this.props;
    const errorObject = _.find(validationErrors, (errObj) =>
      _.has(errObj, SECTION_RESULTS)
    );

    const sectionStatuses = calculateStatuses(_.get(errorObject, SECTION_RESULTS));

    if (!_.isEqual(sectionStatuses, this.props.statuses)) {
      this.props.saveEntitySessionData('context.sectionStatuses', sectionStatuses);
    }
  }

  render() {
    const {
      openButtonLabel,
      closeButtonLabel,
      setCurrentFieldList,
      taskContext,
      submitConfig,
      contents: sections,
      layout,
      globalFields,
    } = this.props;
    let sectionsRendered = _.map(sections, (section) => {
      const status = _.get(this.props.statuses, section.id);
      let hideSection = false;

      // TODO, find better solution than this and what SideNavInternal and DynamicReview does
      // Requires passing props to the ReviewPanel to do ShowHide calculations, maybe do automatically with mapStateToProps based on contents?
      if (section.type === SHOW_HIDE) {
        const propsToPass = {
          ...this.props,
          shouldDisplayIfAnyRules: section.shouldDisplayIfAnyRules,
        };
        const toShow = shouldDisplay(
          undefined,
          undefined,
          section.shouldDisplayRules,
          propsToPass
        );
        if (!toShow) {
          return false;
        }
      }

      return {
        id: section.id,
        name: section.name,
        statusIndicator: true,
        status: status,
        hideSection,
        content: (
          <ContentDispatch
            config={section}
            setCurrentFieldList={setCurrentFieldList}
            taskContext={taskContext}
          />
        ),
      };
    });
    sectionsRendered = _.filter(sectionsRendered, (section) => !!section);

    return (
      <React.Fragment>
        <Flyout
          sections={sectionsRendered}
          showLabel={openButtonLabel}
          hideLabel={closeButtonLabel}
          handleSubmit={this.props.handleSubmit}
          submitConfig={submitConfig}
          layout={layout}
          globalFields={globalFields}
        />
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => ({
  statuses: _.get(state, 'dynamicComponent.context.sectionStatuses'),
});

export default connect(mapStateToProps, null)(connectWithCore(ReviewPanel));
